"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GameResultsTableResultsAgg;
var _react = _interopRequireDefault(require("react"));
var _game_helpers = require("../lib/game_helpers");
var _SortContext = require("./SortContext");
var _FilterContext = require("./FilterContext");
var _icons = _interopRequireDefault(require("../svg/icons.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Build a next object from a key.  This is being done so aggregated and non-aggregated
// sort id's can be kept consistent.
// For example:
// { opponent__name: 'Southern Cal' } -> {opponent: {name: 'Southern Cal'}}
function buildObject(obj) {
  const key = Object.keys(obj)?.[0];
  const value = Object.values(obj)?.[0];
  return key.split('__').reverse().reduce((p, c, i) => {
    return i === 0 ? {
      [c]: value
    } : {
      [(0, _game_helpers.camelize)(c)]: p
    };
  }, {});
}
function GameResultsTableResultsAgg({
  colHeaders,
  matchingGames
}) {
  // const aggOrderCol = getLastToken(Object.keys(colHeaders)[0])
  const aggOrderCol = Object.keys(colHeaders)[0];
  const [sortState, sortDispatch] = (0, _SortContext.useSort)();
  const [{
    filters
  }, filterDispatch] = (0, _FilterContext.useFilters)();
  const resultRows = [];
  let groupedGames = [];
  const hasResults = matchingGames.length !== 0;

  // Aggregate the matched games on the filter provided
  const groupings = (0, _game_helpers.dedunderize)(filters.groupings);
  groupedGames = matchingGames.reduce((groups, game) => {
    const groupingVal = (0, _game_helpers.derefVal)(game, groupings);
    groups[groupingVal] ??= {
      wins: 0,
      losses: 0,
      ties: 0,
      total: 0
    };
    if (game['result'] === 'W') {
      groups[groupingVal]['wins'] += 1;
    } else if (game['result'] === 'L') {
      groups[groupingVal]['losses'] += 1;
    } else {
      groups[groupingVal]['ties'] += 1;
    }
    groups[groupingVal]['total'] += 1;

    // This will be calculated every time, but it will be correct on
    // the last attempt and means we don't have to iterate again.  Seems
    // like this would be faster than iterating again.
    groups[groupingVal]['percentage'] = Number.parseFloat(Math.round(groups[groupingVal]['wins'] / groups[groupingVal]['total'] * 10000.0) / 10000).toFixed(4);
    return groups;
  }, {});
  groupedGames = Object.entries(groupedGames).map(([k, v]) => {
    return {
      ...buildObject({
        [filters.groupings]: k
      }),
      ...v
    };
  });
  groupedGames.sort((0, _game_helpers.compareGames)(sortState.order, sortState.direction));
  groupedGames.forEach(row => {
    const aggColValue = (0, _game_helpers.derefVal)(row, (0, _game_helpers.dedunderize)(aggOrderCol));
    resultRows.push( /*#__PURE__*/_react.default.createElement("tr", {
      key: aggColValue
    }, Object.entries(row).map(([k, v], i) => {
      let isAggCol = i === 0; // The aggregate column should be the first one.
      v = typeof v === 'object' ? aggColValue : v;
      return /*#__PURE__*/_react.default.createElement("td", {
        key: k,
        className: `results-table__agg ${isAggCol ? 'results-table__agg-col' : null} results-table__agg-${k}`
      }, isAggCol ? /*#__PURE__*/_react.default.createElement("button", {
        id: `agg-link-${k}`,
        className: "results-table__link-button",
        onClick: e => {
          e.preventDefault();
          // console.log(aggOrderCol, k, e)
          // onSetFilterFromAggregate(e, v.toLowerCase())
          filterDispatch({
            type: 'CHANGE_AGG',
            filter: {
              key: e.target.id.split('agg-link-')[1],
              value: v.toLowerCase()
            }
          });
        }
      }, v) : v);
    })));
  });

  // Use alphabetical ordering to "toggle" current sort direction
  const sortDirection = sortState.direction > _SortContext.sortDirections.asc ? _SortContext.sortDirections.asc : _SortContext.sortDirections.desc;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, Object.entries(colHeaders).map(([k, v]) => {
    const active = sortState.order === k;
    return (
      /*#__PURE__*/
      // NOTE: class names are used for sorting
      _react.default.createElement("th", {
        id: `table-${k}`,
        className: `results-table__header results-table__agg-${k}`,
        key: k,
        onClick: e => {
          (0, _SortContext.handleSort)(e, sortState, sortDispatch, _SortContext.defaultAggDirections);
        }
      }, /*#__PURE__*/_react.default.createElement("svg", {
        className: `results-table__header-icon ${active && hasResults ? `results-table__header-icon--active results-table__header-icon--${sortDirection}` : null}`,
        fill: "black",
        width: "14px",
        height: "14px"
      }, /*#__PURE__*/_react.default.createElement("use", {
        xlinkHref: `${_icons.default}#icon-sort-${sortDirection}`
      })), /*#__PURE__*/_react.default.createElement("span", {
        className: `results-table__header-span`
      }, v))
    );
  }))), /*#__PURE__*/_react.default.createElement("tbody", null, resultRows));
}